<template>
  <div id="page-wrap">
    <div class="container">
      <div class="nav-tabs-header clearfix">
        <div class="newtex-save hidden-xs">
          视频默认保存位置：
          <i class="iconfont icon-logo"></i>
          <a @click="getPositionTree">&nbsp;{{ position }}</a>
        </div>
      </div>
      <div class="mychilidTab-box clearfix">
        <ul class="nav nav-tabs child-tabs" id="mychlidTab">
          <li class="active" @click="switchTab('file')">
            <a data-toggle="tab" href="#file">文件</a>
          </li>
          <li @click="switchTab('star')">
            <a data-toggle="tab" href="#star">已标星</a>
          </li>
          <li @click="switchTab('trash')">
            <a data-toggle="tab" href="#trash">回收站</a>
          </li>
        </ul>
        <div class="button-container" style="display: block">
          <div
            class="dropdown"
            v-if="this.$store.getters.right__file_number && (tab === 'file')"
            @click="handleUploadVideo"
          >
            <div class="dropdown-toggle">
              <i class="iconfont icon-upload"></i>
              上传
            </div>
          </div>
          <List :isShowList="true" :isList="isList" @showList="showList"></List>
        </div>
      </div>
      <div class="filepath">
        <a class="no-click">返回上一级</a>
        <span class="line">|</span>
        <a @click="resourceSearch">全部文件</a>
      </div>
      <div class="tab-content clearfix" id="dropArea">
        <div class="tab-pane fade in active" id="file">
          <div class="drive">
            <div :class="[isList ? 'lists' : 'grids']">
              <div
                class="list-header"
                id="toplist"
                :class="{ act: selectedCount, a1: showA1 }"
              >
                <div
                  class="item-header"
                  :class="[
                    { 'item-check-header-selected': selectedCount },
                    { 'item-check-header-no-selected': !selectedCount },
                  ]"
                >
                  <div class="checkbox" @click="toggleSelectAll">
                    <i class="ti-check"></i>
                  </div>
                  <div
                    class="item-selected-number"
                    style="display: block"
                    v-if="selectedCount"
                  >
                    已选择{{ selectedCount }}项
                  </div>
                </div>
                <div
                  v-for="header in headers"
                  :key="header.id"
                  class="item-header"
                  :class="'item-' + header.class + '-header'"
                  v-show="!selectedCount && (isList || header.id === 1)"
                  @click="sortByHeader(header.id)"
                >
                  <div class="file-icon" v-show="header.id === 1">
                    <i class="fa fa-file-o"></i>
                  </div>
                  <p>{{ header.title }}</p>
                  <span
                    class="sort"
                    :class="header.sort"
                    v-show="header.showSort"
                  ></span>
                </div>
                <div class="item-header item-menu-header">
                  <p></p>
                </div>
                <div
                  class="item-selected-menu"
                  style="display: block"
                  v-show="selectedCount"
                >
                  <a v-if="!showOnTrash" @click="downloadSelecteds">
                    <i class="ti-download"></i>
                    下载
                  </a>
                  <a
                    data-target="#share2"
                    data-toggle="modal"
                    v-if="right__share_create && !showOnTrash"
                  >
                    <i class="iconfont icon-share"></i>
                    分享
                  </a>
                  <a @click="recycleFileOrFolders" v-if="right__operationFileOrFolder && !showOnTrash">
                    <i class="iconfont icon-trash"></i>
                    删除
                  </a>
                  <a @click="handleData2('restore2')" v-if="right__operationFileOrFolder && showOnTrash">
                    <i class="ti-back-left"></i>
                    还原
                  </a>
                  <a @click="deleteFileOrFolders" v-if="right__operationFileOrFolder && showOnTrash">
                    <i class="iconfont icon-trash"></i>
                    彻底删除
                  </a>
                  <div class="dropdown" v-show="showHeaderMoreBtn && !showOnTrash">
                    <a
                      aria-expanded="true"
                      aria-haspopup="true"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      id="dropdownMenu2"
                    >
                      <i class="iconfont icon-more"></i>
                      更多
                    </a>
                    <ul
                      aria-labelledby="dropdownMenu2"
                      class="dropdown-menu dropdown-menu-right"
                    >
                      <li
                        v-if="right__rename && !showOnTrash && selectedCount === 1"
                        @click="handleSelectedRename"
                      >
                        <a>
                          <i class="iconfont icon-send"></i>
                          重命名
                        </a>
                      </li>
                      <li v-if="right__operationFileOrFolder && !showOnTrash">
                        <a @click="handleData2('move2')">
                          <i class="iconfont icon-move"></i>
                          移动到
                        </a>
                      </li>
                      <!-- <li v-if="right__operationFileOrFolder">
                        <a @click="handleData2('copy2')">
                          <i class="iconfont icon-copy"></i>
                          复制到
                        </a>
                      </li> -->
                    </ul>
                  </div>
                </div>
              </div>
              <div class="list-content">
                <div
                  class="itemlist"
                  v-for="data in datas"
                  :key="data.number"
                  :class="{ act: data.isSelected ? true : false }"
                  @contextmenu.prevent="rightEvent(data, $event)"
                  @click="selectRow(data)"
                >
                  <div class="item-check">
                    <div class="checkbox">
                      <i class="ti-check"></i>
                    </div>
                  </div>
                  <div class="item-name">
                    <div class="file-icon" @click.stop="handleClickIcon(data)">
                      <svg aria-hidden="true" class="icon">
                        <use
                          :xlink:href="
                            '#icon-' +
                            getIcon(data.type, data.file_type, data.file_ext)
                          "
                        />
                      </svg>
                    </div>
                    <input
                      v-focus="focusState"
                      v-if="data.isEdit"
                      type="text"
                      class="fileName"
                      :value="data.name"
                      @keyup.esc="cancleRename(data)"
                      @keyup.enter="renameByEnter(data, $event)"
                      @click.stop="`return false`"
                    />
                    <button
                      class="btn btn-info"
                      title="保存"
                      type="button"
                      v-if="data.isEdit"
                      @click.stop="renameByBtn(data, $event)"
                      :disabled="isProcessing"
                    >
                      <i
                        :class="[
                          'fa',
                          isProcessing ? 'fa-spinner' : 'fa-check',
                        ]"
                      ></i>
                    </button>
                    <button
                      class="btn btn-info"
                      title="取消"
                      type="button"
                      v-if="data.isEdit"
                      @click.stop="cancleRename(data)"
                      :disabled="isProcessing"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                    <span
                      class="help-rename"
                      v-show="data.isEdit && errors.has('title')"
                      >{{ errors.first("title") }}</span
                    >
                    <div v-show="!data.isEdit">
                      <div v-if="!showOnTrash">
                        <div class="file-name">
                          <p
                            class="file-name-data"
                            :title="data | formatData"
                            @click.stop="preview(data)"
                          >
                            {{ data | formatData }}
                          </p>
                          <!-- <span
                            v-if="
                              data.transcode_status !== 'none' &&
                              !data.isEdit &&
                              (showOnFile || showOnStar) &&
                              isList
                            "
                            :class="data | transcodeStatusFilter"
                            class="isTransed"
                            @click.stop="fileTranstate(data, $event)"
                            :title="data.transcode_title"
                          ></span> -->
                          <span
                            v-if="data.is_lock === true && isList"
                            class="glyphicon glyphicon-lock isLocked"
                            :title="
                              data.lock_reason ? data.lock_reason : '锁定'
                            "
                          ></span>
                          <span
                            v-if="data.share_count"
                            class="glyphicon glyphicon-share isShared"
                            title="已分享"
                          ></span>
                        </div>
                        <div
                          @click.stop="goToFolder(data)"
                          class="file-path"
                          :title="data | positionFilter"
                        >
                          {{ data | positionFilter }}
                        </div>
                      </div>
                      <p v-if="showOnTrash">
                        <a
                          @click.stop="handleTrash"
                          :title="data | formatData"
                          >{{ data | formatData }}</a
                        >
                      </p>
                    </div>
                  </div>
                  <div class="item-size">{{ data | bytesToSize }}</div>
                  <div class="item-time">
                    <span class="item-date-sm">{{
                      data.last_update_date ? data.last_update_date : "-"
                    }}</span>
                  </div>
                  <div class="item-author">
                    {{
                      data.creater_user_real_name
                        ? data.creater_user_real_name
                        : "-"
                    }}
                  </div>
                  <div class="item-menu">
                    <a
                      v-if="right__resource_tag && !showOnTrash"
                      class="hidden-xs"
                      @click.stop="handleData(data, 'tag')"
                    >
                      <i class="iconfont icon-tag" title="标签"></i>
                    </a>
                    <a
                      v-if="right__share_create && !showOnTrash"
                      class="hidden-xs"
                      @click.stop="handleData(data, 'share')"
                    >
                      <i class="iconfont icon-share" title="分享"></i>
                    </a>
                    <a
                      v-if="right__startag && !showOnTrash"
                      class="star hidden-xs"
                      @click.stop="toggleStar(data)"
                    >
                      <i
                        class="iconfont"
                        :class="[data.is_star ? 'icon-star-full' : 'icon-star']"
                        title="星标"
                      ></i>
                    </a>
                    <div class="dropdown" ref="dropdown" v-if="showMoreBtn">
                      <a
                        aria-expanded="true"
                        aria-haspopup="true"
                        class="dropdown-toggle"
                        id="dropdownMenu2"
                        data-toggle="dropdown"
                        @click.stop="toggleDropdown($event)"
                      >
                        <i class="iconfont icon-more" title="更多"></i>
                      </a>
                      <ul
                        aria-labelledby="dropdownMenu2"
                        class="dropdown-menu dropdown-menu-right"
                      >
                        <li v-if="!showOnTrash">
                          <a @click.stop="download(data)">
                            <i class="ti-download"></i>
                            下载
                          </a>
                        </li>
                        <li v-if="right__operationFileOrFolder && !showOnTrash">
                          <a @click.stop="recycleFileOrFolder(data)">
                            <i class="iconfont icon-trash"></i>
                            删除
                          </a>
                        </li>
                        <li v-if="right__operationFileOrFolder && showOnTrash">
                          <a @click.stop="deleteFileOrFolder(data)">
                            <i class="iconfont icon-trash"></i>
                            彻底删除
                          </a>
                        </li>
                        <li v-if="right__operationFileOrFolder && showOnTrash">
                          <a @click.stop="handleTreeData(data, 'restore')">
                            <i class="ti-back-left"></i>
                            还原
                          </a>
                        </li>
                        <li v-if="right__rename && !showOnTrash">
                          <a @click.stop="handleRename(data)">
                            <i class="iconfont icon-send"></i>
                            重命名
                          </a>
                        </li>
                        <!-- <li v-if="right__operationFileOrFolder && !showOnTrash">
                          <a @click.stop="handleTreeData(data, 'copy')">
                            <i class="iconfont icon-copy"></i>
                            复制到
                          </a>
                        </li> -->
                        <li v-if="right__operationFileOrFolder && !showOnTrash">
                          <a @click.stop="handleTreeData(data, 'move')">
                            <i class="iconfont icon-move"></i>
                            移动到
                          </a>
                        </li>
                        <li v-if="right__file_version_back_preview && !showOnTrash">
                          <a @click="handleData(data, 'file-history')">
                            <i class="iconfont icon-link-check"></i>
                            历史版本
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="loadingbox" v-show="loading">
                  <section class="loading Animation1">
                    <section class="shape shape-1"></section>
                    <section class="shape shape-2"></section>
                    <section class="shape shape-3"></section>
                    <section class="shape shape-4"></section>
                  </section>
                  <h4>正在加载，请稍后……</h4>
                </div>
                <div class="nofile nofile-padding" v-if="nothing && showOnFile">
                  <div class="pic">
                    <img src="@/assets/images/nofile.svg" />
                  </div>
                  <h4>还没上传任何文件</h4>
                  <p>将个人文件存放到云盘中以便随时访问它们。</p>
                  <div class="nobtn" v-if="this.$store.getters.right__file_number">
                    <div class="dropdown">
                      <button
                        class="btn btn-primary"
                        type="button"
                        @click="handleUploadVideo"
                      >
                        <i class="iconfont icon-upload"></i>
                        上传
                      </button>
                    </div>
                  </div>
                </div>
                <div class="nofile" v-if="nothing && showOnStar">
                  <div class="pic">
                    <img src="@/assets/images/nocollect.svg" />;
                  </div>
                  <h4>还没任何标星文件</h4>
                  <p>
                    将个人云盘文件中经常需要用到的文档标星，可以在这里快速找到它们。
                  </p>
                </div>
                <div class="nofile" v-if="nothing && showOnTrash">
                  <div class="pic">
                    <img src="@/assets/images/norecover.svg" />
                  </div>
                  <h4>回收站为空，没有要回收的项。</h4>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Page
        v-show="!loading"
        :page-index="currentPage"
        :total="count"
        :page-size="listQuery.limit"
        @change="pageChange"
      ></Page>
    </div>
    <TableMove
      :detail="detail"
      @reloadInfo="resourceSearch"
      v-if="status.TableMove"
    ></TableMove>
    <TableMoveSelected
      :selectedDatas="selectedDatas"
      @reloadInfo="resourceSearch"
      v-if="status.TableMoveSelected"
    ></TableMoveSelected>
    <TableRestore
      :detail="detail"
      @reloadInfo="resourceSearch"
      v-if="status.TableRestore"
    ></TableRestore>
    <TableRestoreSelected
      :selectedDatas="selectedDatas"
      @reloadInfo="resourceSearch"
      v-if="status.TableRestoreSelected"
    ></TableRestoreSelected>
    <TableCopy
      :detail="detail"
      @reloadInfo="resourceSearch"
      v-if="status.TableCopy"
    ></TableCopy>
    <TableCopySelected
      :selectedDatas="selectedDatas"
      @reloadInfo="resourceSearch"
      v-if="status.TableCopySelected"
    ></TableCopySelected>
    <TableShare :detail="detail" v-if="status.TableShare"></TableShare>
    <TableShareSelected
      :selectedDatas="selectedDatas"
      v-if="status.TableShareSelected"
    ></TableShareSelected>
    <TableTag :detail="detail" v-if="status.TableTag"></TableTag>
    <videoPreview
      :detail="detail"
      v-if="status.videoPreview"
      @handlePreviewData="handlePreviewData"
      @deletePreviewData="deletePreviewData"
    ></videoPreview>
    <TableSavePosition
      :app="app"
      :selectedFolder="selectedFolder"
      @appInfo="appInfo"
      v-if="status.TableSavePosition"
    ></TableSavePosition>
    <FileHistory :detail="detail"></FileHistory>
    <div
      class="right-menu"
      :style="rightMenustyle"
      v-if="showRightMenu"
      v-clickoutside="closeRightMenu"
    >
      <a
        v-if="right__resource_tag && !showOnTrash"
        class="hidden-xs"
        @click="handleData(detail, 'tag')"
      >
        <i class="iconfont icon-tag"></i>
        标签
      </a>
      <a
        v-if="right__share_create && !showOnTrash"
        class="hidden-xs"
        @click="handleData(detail, 'share')"
      >
        <i class="iconfont icon-share"></i>
        分享
      </a>
      <a v-if="right__startag && !showOnTrash" class="star hidden-xs" @click="toggleStar(detail)">
        <i
          class="iconfont"
          :class="[detail.is_star ? 'icon-star-full' : 'icon-star']"
        ></i>
        {{ detail.is_star ? "取消星标" : "星标" }}
      </a>
      <a
        v-if="detail.type === 'file' && (showOnFile || showOnStar)"
        @click="preview(detail)"
      >
        <i class="glyphicon glyphicon-eye-open"></i>
        预览
      </a>
      <a
        v-if="(showOnFile || showOnStar) && detail.type === 'file'"
        @click="download(detail)"
      >
        <i class="ti-download"></i>
        下载
      </a>
      <a v-if="right__rename && (showOnFile || showOnStar)" @click="handleRename(detail)">
        <i class="iconfont icon-send"></i>
        重命名
      </a>
      <!-- <a
        v-if="right__operationFileOrFolder && (showOnFile || showOnStar)"
        @click="handleTreeData(detail, 'copy')"
      >
        <i class="iconfont icon-copy"></i>
        复制到
      </a> -->
      <a
        v-if="right__operationFileOrFolder && (showOnFile || showOnStar)"
        @click="handleTreeData(detail, 'move')"
      >
        <i class="iconfont icon-move"></i>
        移动到
      </a>
      <a v-if="right__operationFileOrFolder && showOnTrash" @click="handleTreeData(detail, 'restore')">
        <i class="ti-back-left"></i>
        还原
      </a>
      <a v-if="right__operationFileOrFolder && showOnTrash" @click="deleteFileOrFolder(detail)">
        <i class="iconfont icon-trash"></i>
        彻底删除
      </a>
      <a v-if="right__operationFileOrFolder && (showOnFile || showOnStar)" @click="recycleFileOrFolder(detail)">
        <i class="iconfont icon-trash"></i>
        删除
      </a>
      <a
        v-if="right__file_version_back_preview && (showOnFile || showOnStar)"
        @click="handleData(detail, 'file-history')"
      >
        <i class="iconfont icon-link-check"></i>
        历史版本
      </a>
    </div>
  </div>
</template>

<script>
import { appInfo } from "@/api/common/index";
import { getIcon } from "@/utils/icon";
import {
  bytesToSize,
  listToTree,
  listToTree2,
  transcodeStatusFilter,
  formatData,
  formatSeconds,
  positionFilter,
} from "@/utils/index";
import { verifyFilename } from "@/utils/verify";
import Bus from "@/utils/bus";
import {
  resourceSearch,
  getFileInfo,
  download,
  toggleStar,
  operationFileOrFolder,
  rename,
  fileTranstate,
  fileTranstateStatus,
  preview,
} from "@/api/drive/drive";
export default {
  name: "Videos",
  components: {
    videoPreview: () => import("@/components/Table/TablePreview/videoPreview"),
    List: () => import("@/views/Common/List"),
    TableTag: () => import("@/components/Table/TableOperate/TableTag"),
    TableShare: () => import("@/components/Table/TableOperate/TableShare"),
    TableShareSelected: () => import("./TableShareSelected"),
    TableMove: () => import("@/components/Table/TableOperate/TableMove"),
    TableMoveSelected: () => import("./TableMoveSelected"),
    TableRestore: () => import("@/components/Table/TableOperate/TableRestore"),
    TableRestoreSelected: () => import("./TableRestoreSelected"),
    TableCopy: () => import("@/components/Table/TableOperate/TableCopy"),
    TableCopySelected: () => import("./TableCopySelected"),
    TableSavePosition: () => import("./TableSavePosition"),
    Page: () => import("./Page"),
    FileHistory: () => import("@/components/Table/TableOperate/FileHistory"),
  },
  data() {
    return {
      isProcessing: false,
      status: {
        videoPreview: false,
        TableTag: false,
        TableShare: false,
        TableShareSelected: false,
        TableMove: false,
        TableMoveSelected: false,
        TableRestore: false,
        TableRestoreSelected: false,
        TableCopy: false,
        TableCopySelected: false,
        TableSavePosition: false,
      },
      loading: false,
      nothing: false,
      rightMenustyle: {},
      showRightMenu: false,
      currentPage: 1, //当前页码
      count: 0, //总记录数
      selectedFolder: null,
      app: {
        app_number: "40289f6263cd99c90163cdd1e4ee0005",
        app_save_folder_path_name: "",
      },
      tab: "file",
      isList: true,
      showA1: false,
      sort: {},
      detail: {},
      datas: [],
      selectedDatas: [],
      listQuery: {
        disk_type: "cloud",
        group_number: this.$store.state.user.userInfo.group_number,
        category: "video",
        is_star: false,
        offset: 0,
        limit: 21,
      },
      headers: [
        {
          id: 1,
          title: "名称",
          class: "name",
          sort: "des",
          showSort: false,
          field: "name",
        },
        {
          id: 2,
          title: "大小",
          class: "size",
          sort: "des",
          showSort: false,
          field: "bytes",
        },
        {
          id: 3,
          title: "修改日期",
          class: "time",
          sort: "des",
          showSort: true,
          field: "last_update_date",
        },
        {
          id: 4,
          title: "创建人",
          class: "author",
          sort: "des",
          showSort: false,
          field: "creater_user_real_name",
        },
      ],
    };
  },
  created() {
    this.$store.commit("SET_THEME", "视频");
    this.$store.commit("SET_GROUP_NUMBER", null);
    this.sort = this.headers[2];
    this.resourceSearch();
    this.appInfo();
  },
  watch: {
    $route() {
      this.$store.commit("SET_THEME", "视频");
      this.$store.commit("SET_GROUP_NUMBER", null);
      this.sort = this.headers[2];
      this.resourceSearch();
      this.appInfo();
    },
  },
  filters: {
    transcodeStatusFilter: transcodeStatusFilter,
    positionFilter: positionFilter,
    formatData: formatData,
    bytesToSize: bytesToSize,
  },
  computed: {
    showHeaderMoreBtn () {
      return (this.right__rename && !this.showOnTrash && this.selectedCount === 1)
       || (this.right__operationFileOrFolder && !this.showOnTrash)
       || this.right__operationFileOrFolder
    },
    showMoreBtn () {
      return (!this.showOnTrash)
       || (this.right__operationFileOrFolder && !this.showOnTrash)
       || (this.right__operationFileOrFolder && this.showOnTrash)
       || (this.right__file_version_back_preview && !this.showOnTrash)
       || (this.right__rename && !this.showOnTrash)
    },
    right__file_version_back_preview () {
      return this.$store.getters.right__file_version_back_preview
    },
    right__share_create () {
      return this.$store.getters.right__share_create
    },
    right__resource_tag () {
      return this.$store.getters.right__resource_tag
    },
    right__startag () {
      return this.$store.getters.right__startag
    },
    right__rename () {
      return this.$store.getters.right__rename
    },
    right__operationFileOrFolder () {
      return this.$store.getters.right__operationFileOrFolder
    },
    focusState() {
      return this.$store.state.drive.focusState;
    },
    position() {
      return this.app.app_save_folder_number == 0
        ? "我的云盘"
        : this.app.app_save_folder_path_name.substring(
            this.app.app_save_folder_path_name.lastIndexOf("/") + 1,
            this.app.app_save_folder_path_name.length
          );
    },
    selectedCount() {
      return this.selectedDatas.length;
    },
    showOnFile: function () {
      return this.tab === "file";
    },
    showOnStar: function () {
      return this.tab === "star";
    },
    showOnTrash: function () {
      return this.tab === "trash";
    },
  },
  directives: {
    clickoutside: {
      bind(el, binding, vnode) {
        function documentHandler(e) {
          // 这里判断点击的元素是否是本身，是本身，则返回
          if (el.contains(e.target)) {
            return false;
          }
          // 判断指令中是否绑定了函数
          if (binding.expression) {
            // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
            binding.value(e);
          }
        }
        // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
        el.__vueClickOutside__ = documentHandler;
        document.addEventListener("click", documentHandler);
      },
      unbind(el, binding) {
        // 解除事件监听
        document.removeEventListener("click", el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      },
    },
  },
  methods: {
    handlePreviewData(payload) {
      // 仅选中该条数据
      this.selectOneRow(payload.data);
      switch (payload.action) {
        case "move":
          this.handleTreeData(payload.data, "move");
          break;
        case "copy":
          this.handleTreeData(payload.data, "copy");
          break;
        case "share":
          this.detail = payload.data;
          $("#share").modal("show");
          break;
      }
      this.imgs = [];
    },
    deletePreviewData(data) {
      let index = this.datas.findIndex((item) => {
        return item.number === data.number;
      });
      this.datas.splice(index, 1);
      // this.resourceSearch();
    },
    // 跳转到云盘
    goToFolder(file) {
      this.$router.push({
        name: "recdrive",
        query: {
          tab: "file",
          number: file.parent_number,
          disk_type: file.disk_type,
        },
      });
    },
    toggleDropdown(event) {
      this.showRightMenu = false;
      this.$refs.dropdown.map((item) => {
        if (item === event.currentTarget.parentNode) {
          $(event.currentTarget).parent().toggleClass("open");
        } else {
          item.classList.remove("open");
        }
      });
    },
    handleClickIcon(data) {
      if (this.showOnTrash) {
        this.handleTrash();
      } else {
        this.preview(data);
      }
    },
    closeRightMenu() {
      this.showRightMenu = false;
    },
    rightEvent(data, e) {
      this.detail = data;
      this.rightMenustyle = {
        left: e.clientX + 5 + "px",
        top: e.clientY + 5 + "px",
      };
      this.showRightMenu = true;
      // 关闭每行的dropdown
      this.$refs.dropdown.map((item) => {
        item.classList.remove("open");
      });
      this.selectOneRow(data);
    },
    selectOneRow(payload) {
      this.selectedDatas = [];
      let that = this;
      this.datas.map(function (data) {
        if (data.number === payload.number) {
          payload.isSelected = true;
          that.selectedDatas.push(payload);
        } else {
          data.isSelected = false;
        }
        return data;
      });
    },
    fileTranstate(data, event) {
      this.detail = data;
      let e = event.target;
      $(e).css({ "pointer-events": "none" });
      setTimeout(() => {
        $(e).css({ "pointer-events": "auto" });
      }, 5000);
      if (data.transcode_status == "wait" || data.transcode_status == "fail") {
        this.$confirm({
          type: "confirm",
          content: "确定要提交转码吗？",
          showCancleBtn: true,
          showYesBtn: true,
          custom: [],
        })
          .then(() => {
            fileTranstate({
              file_number: data.number,
              group_number: null,
            })
              .then((res) => {
                if (res.status_code === 202) {
                  data.transcode_title = "视频正在转码，请稍等";
                  data.transcode_status = "progess";
                  this.$message({
                    type: "warning",
                    message: res.message,
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: err,
                });
              });
          })
          .catch(() => {});
      } else if (data.transcode_status == "progess") {
        this.fileTranstateStatus(data)
          .then((res) => {
            if (res.status_code === 200) {
              if (res.entity.trans_status == "progess") {
                this.$message({
                  type: "warning",
                  message: `该视频正在转码，已完成${
                    res.entity.trans_percentage
                  }%，预计需要${formatSeconds(res.entity.take_time)}，请稍等`,
                });
              } else if (res.entity.trans_status == "success") {
                data.transcode_status = "success";
                data.transcode_title = "视频转码成功，可以播放";
                // 转码成功，直接播放
                this.getPreviewPath(data).then(() => {
                  $("#video_preview").modal("show");
                });
              } else if (res.entity.trans_status == "wait") {
                this.$message({
                  type: "warning",
                  message: `该视频正在等待转码，前面排队的数量${
                    res.entity.trans_queue_count
                  }，预计需要${formatSeconds(res.entity.take_time)}，请稍等`,
                });
              } else if (res.entity.trans_status == "fail") {
                data.transcode_status = "fail";
                data.transcode_title = "视频转码失败，点击重试";
                this.$message({
                  type: "error",
                  message: res.entity.trans_message,
                });
              }
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      }
    },
    // 转码状态
    fileTranstateStatus(data) {
      return new Promise((resolve, reject) => {
        fileTranstateStatus({
          number: data.number,
          group_number: null,
        })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    //从page组件传递过来的当前page
    pageChange(page) {
      this.currentPage = page;
      this.listQuery.offset = (this.currentPage - 1) * this.listQuery.limit;
      this.resourceSearch();
    },
    handleTrash() {
      this.$message({
        type: "warning",
        message: "回收站中不支持打开操作",
      });
    },
    getPositionTree() {
      let that = this;
      let expanded =
        this.app.app_save_folder_number == 0
          ? []
          : this.app.app_save_folder_path_number.split("/");
      getFileInfo({
        number: 0,
        is_rec: true,
        category: "folder",
        disk_type: "cloud",
      })
        .then((res) => {
          this.selectedFolder = {
            number: this.app.app_save_folder_number,
          };
          let tree = [
            {
              disk_type: "cloud",
              number: "0",
              text: "我的云盘",
              state: {
                selected: this.app.app_save_folder_number == 0 ? true : false,
              },
              nodes: listToTree2(
                res.entity.datas,
                expanded,
                this.app.app_save_folder_number
              ),
            },
          ];
          $("#treeview-position").treeview({
            expandIcon: "ti ti-angle-right",
            collapseIcon: "ti ti-angle-down",
            nodeIcon: "iconfont icon-folder",
            showTags: true,
            onNodeSelected: function (event, data) {
              that.selectedFolder = data;
            },
            onNodeUnselected: function (event, data) {
              that.selectedFolder = null;
            },
            data: tree,
          });
          $("#position").modal("show");
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    appInfo() {
      appInfo({
        app_number: this.app.app_number,
        group_number: null,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.app = res.entity;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    handleUploadVideo() {
      Bus.$emit("video", this.app.app_save_folder_number);
    },
    downloadSelecteds() {
      if (this.selectedCount > 1) {
        this.$confirm({
          type: "confirm",
          content: `确定批量下载这${this.selectedCount}个文件吗？`,
          showCancleBtn: true,
          showYesBtn: true,
          custom: [],
        })
          .then(() => {
            this.downloadSelectedsByStep();
          })
          .catch(() => {});
      } else {
        this.downloadSelectedsByStep();
      }
    },
    downloadSelectedsByStep() {
      this.selectedDatas.map((data) => {
        download({
          files_list: [data.number],
          group_number: null,
        })
          .then((res) => {
            if (res.status_code === 200) {
              const iframe = window.document.createElement("iframe");
              iframe.style.display = "none";
              iframe.style.height = 0;
              iframe.src = res.entity[data.number] + "&download=download";
              document.body.appendChild(iframe);
              // 10s之后删除
              setTimeout(() => {
                iframe.remove();
              }, 10000);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      });
    },
    deleteDatas() {
      this.datas = this.datas.filter((item) => {
        return !this.selectedDatas.includes(item);
      });
      if (this.datas.length < 1) {
        this.nothing = true;
      }
      this.selectedDatas = [];
    },
    deleteData(data) {
      let index = this.datas.indexOf(data);
      this.datas.splice(index, 1);
      if (this.datas.length < 1) {
        this.nothing = true;
      }
      let index2 = this.selectedDatas.indexOf(data);
      if (index2 > -1) {
        this.selectedDatas.splice(index2, 1);
      }
    },
    recycleFileOrFolders() {
      this.$confirm({
        type: "confirm",
        content: `确定删除吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          let files_list = this.selectedDatas.map((data) => {
            return {
              number: data.number,
              type: data.type,
            };
          });
          operationFileOrFolder({
            group_number: null,
            action: "recycle",
            disk_type: "cloud",
            files_list: files_list,
          })
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.deleteDatas();
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch();
        })
        .catch(() => {});
    },
    recycleFileOrFolder(data) {
      this.showRightMenu = false;
      this.$confirm({
        type: "confirm",
        content: `确定删除【${formatData(data)}】吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          operationFileOrFolder({
            group_number: data.group_number,
            action: "recycle",
            disk_type: "cloud",
            files_list: [
              {
                number: data.number,
                type: data.type,
              },
            ],
          })
            .then((res) => {
              if (res.status_code === 200) {
                this.deleteData(data);
                this.$message({
                  type: "success",
                  message: res.message,
                });
              } else if (res.status_code === 410) {
                this.deleteData(data);
                this.$message({
                  type: "error",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch();
        })
        .catch(() => {});
    },
    deleteFileOrFolders() {
      this.$confirm({
        type: "confirm",
        content: `确定彻底删除吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          let files_list = this.selectedDatas.map((data) => {
            return {
              number: data.number,
              type: data.type,
            };
          });
          operationFileOrFolder({
            group_number: null,
            action: "delete",
            disk_type: "cloud",
            files_list: files_list,
          })
            .then((res) => {
              if (res.status_code === 200) {
                this.$message({
                  type: "success",
                  message: res.message,
                });
                this.deleteDatas();
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch();
        })
        .catch(() => {});
    },
    deleteFileOrFolder(data) {
      this.showRightMenu = false;
      this.$confirm({
        type: "confirm",
        content: `确定彻底删除【${formatData(data)}】吗？`,
        showCancleBtn: true,
        showYesBtn: true,
        custom: [],
      })
        .then(() => {
          operationFileOrFolder({
            group_number: data.group_number,
            action: "delete",
            disk_type: "cloud",
            files_list: [
              {
                number: data.number,
                type: data.type,
              },
            ],
          })
            .then((res) => {
              if (res.status_code === 200) {
                this.deleteData(data);
                this.$message({
                  type: "success",
                  message: res.message,
                });
              } else if (res.status_code === 410) {
                this.deleteData(data);
                this.$message({
                  type: "error",
                  message: res.message,
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.message,
                });
              }
            })
            .catch();
        })
        .catch(() => {});
    },
    download(data) {
      this.showRightMenu = false;
      download({
        files_list: [data.number],
        group_number: null,
      })
        .then((res) => {
          if (res.status_code === 200) {
            window.location.href =
              res.entity[data.number] + "&download=download";
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    cancleRename(data) {
      data.isEdit = false;
      this.$nextTick(function () {
        this.$store.commit("setFocusState", false);
      });
    },
    handleRename(data) {
      this.$store.commit("setFocusState", false);
      this.showRightMenu = false;
      data.isEdit = true;
      this.$nextTick(function () {
        this.$store.commit("setFocusState", true);
      });
    },
    handleSelectedRename() {
      this.selectedDatas[0].isEdit = true;
      this.$nextTick(function () {
        this.$store.commit("setFocusState", true);
      });
    },
    // 通过按Enter保存
    renameByEnter(data, event) {
      if (this.isProcessing) {
        return false;
      }
      this.isProcessing = true;
      let value = $(event.currentTarget).val().trim();
      this.rename(data, value);
    },
    // 通过点击保存按钮保存
    renameByBtn(data, event) {
      if (this.isProcessing) {
        return false;
      }
      this.isProcessing = true;
      let value = $(event.currentTarget).prev().val().trim();
      this.rename(data, value);
    },
    rename(data, value) {
      let validObj = verifyFilename(value);
      if (!validObj.valid) {
        this.errors.remove("title");
        this.errors.add({
          field: "title",
          msg: validObj.msg,
        });
        this.isProcessing = false;
        return false;
      } else {
        this.errors.remove("title");
      }
      rename({
        name: value,
        number: data.number,
        type: data.type,
        group_number: null,
      })
        .then((res) => {
          if (res.status_code === 200) {
            this.isProcessing = false;
            this.$message({
              type: "success",
              message: res.message,
            });
            data.name = res.entity.new_name;
            data.last_update_date = res.entity.last_update_date;
            data.isEdit = false;
            this.$store.commit("setFocusState", false);
          } else {
            this.isProcessing = false;
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.isProcessing = false;
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    toggleStar(data) {
      this.showRightMenu = false;
      toggleStar({
        is_star: !data.is_star,
        paramslist: [
          {
            number: data.number,
            type: data.type,
          },
        ],
      })
        .then((res) => {
          if (res.status_code === 200) {
            if (this.tab === "star") {
              this.deleteData(data);
            } else {
              data.is_star = !data.is_star;
            }
          } else if (res.status_code === 410) {
            this.deleteData(data);
            this.$message({
              type: "error",
              message: res.message,
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    handleData2(action) {
      this.getTree2(action);
    },
    getTree2(action) {
      let that = this;
      getFileInfo({
        number: 0,
        is_rec: true,
        category: "folder",
        disk_type: "cloud",
      })
        .then((res) => {
          let except = action === "move2" ? this.selectedDatas : [];
          let tree = [
            {
              disk_type: "cloud",
              number: "0",
              text: "我的云盘",
              selectable:
                this.selectedDatas[0].parent_number === "0" &&
                this.selectedDatas[0].disk_type === "cloud" &&
                action === "move2"
                  ? false
                  : true,
              nodes: listToTree(res.entity.datas, except),
            },
          ];
          $("#treeview-" + action).treeview({
            expandIcon: "ti ti-angle-right",
            collapseIcon: "ti ti-angle-down",
            nodeIcon: "iconfont icon-folder",
            showTags: true,
            onNodeSelected: function (event, data) {
              that.$store.commit("selectedFolder", data);
            },
            onNodeUnselected: function (event, data) {
              that.$store.commit("selectedFolder", null);
            },
            data: tree,
          });
          $("#" + action).modal("show");
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    handleData(data, action = null) {
      this.showRightMenu = false;
      this.detail = data;
      $("#" + action).modal("show");
    },
    handleTreeData(data, action = null) {
      this.showRightMenu = false;
      this.detail = data;
      if (action) {
        this.getTree(action);
      }
    },
    getTree(action) {
      let that = this;
      getFileInfo({
        number: 0,
        is_rec: true,
        category: "folder",
        disk_type: "cloud",
      })
        .then((res) => {
          let except = action === "move" ? this.selectedDatas : [];
          let tree = [
            {
              disk_type: "cloud",
              number: "0",
              text: "我的云盘",
              selectable:
                this.detail.parent_number === "0" &&
                this.detail.disk_type === "cloud" &&
                action === "move"
                  ? false
                  : true,
              nodes: listToTree(res.entity.datas, except),
            },
          ];
          $("#treeview-" + action).treeview({
            expandIcon: "ti ti-angle-right",
            collapseIcon: "ti ti-angle-down",
            nodeIcon: "iconfont icon-folder",
            showTags: true,
            onNodeSelected: function (event, data) {
              that.$store.commit("selectedFolder", data);
            },
            onNodeUnselected: function (event, data) {
              that.$store.commit("selectedFolder", null);
            },
            data: tree,
          });
          $("#" + action).on("hidden.bs.modal", function (e) {
            that.detail = {};
          });
          $("#" + action).modal("show");
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
    switchTab(tab) {
      this.tab = tab;
      this.listQuery.offset = 0;
      this.currentPage = 1;
      switch (tab) {
        case "file":
          this.listQuery.disk_type = "cloud";
          this.listQuery.is_star = false;
          break;
        case "star":
          this.listQuery.disk_type = "cloud";
          this.listQuery.is_star = true;
          break;
        case "trash":
          this.listQuery.disk_type = "recycle";
          this.listQuery.is_star = false;
          break;
      }
      this.resourceSearch();
    },
    showList(isList) {
      this.isList = isList;
    },
    sortByHeader(id) {
      let that = this;
      this.headers.map(function (item) {
        if (item.id === id) {
          that.sort = item;
          item.showSort = true;
          item.sort = item.sort === "des" ? "asc" : "des";
          return item;
        }
        item.showSort = false;
        item.sort = "des";
        return item;
      });
      this.sortBy();
    },
    sortBy() {
      let that = this;
      switch (this.sort.id) {
        case 2:
          this.datas.sort(function (x, y) {
            let ind = x[that.sort.field] - y[that.sort.field];
            return that.sort.sort === "asc" ? ind : -ind;
          });
          break;
        case 3:
          this.datas.sort(function (x, y) {
            let ind =
              new Date(x[that.sort.field]).getTime() -
              new Date(y[that.sort.field]).getTime();
            return that.sort.sort === "asc" ? ind : -ind;
          });
          break;
        default:
          this.datas.sort(function (x, y) {
            let ind = x[that.sort.field].localeCompare(y[that.sort.field]);
            return that.sort.sort === "asc" ? ind : -ind;
          });
      }
    },
    getPreviewPath(data) {
      return new Promise((resolve) => {
        preview({
          number: data.number,
          group_number: null,
        })
          .then((res) => {
            if (res.status_code === 200) {
              if (data.is_lock) {
                this.$message({
                  type: "warning",
                  message: `该文件已被锁定，锁定原因：${data.lock_reason}。如需解锁，请联系管理员`,
                });
                return false;
              }
              resolve(res);
            } else if (res.status_code === 410) {
              this.$message({
                type: "error",
                message: res.message,
              });
              let index = this.datas.indexOf(data);
              this.datas.splice(index, 1);
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      });
    },
    preview(data) {
      this.showRightMenu = false;
      this.detail = data;
      if (
        data.transcode_status == "none" ||
        data.transcode_status == "success"
      ) {
        this.getPreviewPath(data).then(() => {
          $("#video_preview").modal("show");
        });
      } else if (data.transcode_status == "wait") {
        this.$message({
          type: "warning",
          message: "视频暂未转码，请先点击转码，转码完成后即可播放",
        });
      } else if (data.transcode_status == "progess") {
        this.fileTranstateStatus(data)
          .then((res) => {
            if (res.status_code === 200) {
              if (res.entity.trans_status == "progess") {
                this.$message({
                  type: "warning",
                  message: `该视频正在转码，已完成${
                    res.entity.trans_percentage
                  }%，预计需要${formatSeconds(res.entity.take_time)}，请稍等`,
                });
              } else if (res.entity.trans_status == "success") {
                data.transcode_status = "success";
                data.transcode_title = "视频转码成功，可以播放";
                // 转码成功，直接播放
                this.getPreviewPath(data).then(() => {
                  $("#video_preview").modal("show");
                });
              } else if (res.entity.trans_status == "wait") {
                this.$message({
                  type: "warning",
                  message: `该视频正在等待转码，前面排队的数量${
                    res.entity.trans_queue_count
                  }，预计需要${formatSeconds(res.entity.take_time)}，请稍等`,
                });
              } else if (res.entity.trans_status == "fail") {
                data.transcode_status = "fail";
                data.transcode_title = "视频转码失败，点击重试";
                this.$message({
                  type: "error",
                  message: res.entity.trans_message,
                });
              }
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err,
            });
          });
      } else if (data.transcode_status == "fail") {
        this.$message({
          type: "error",
          message: "视频转码失败，无法播放",
        });
      } else if (data.transcode_status == "notran") {
        this.$message({
          type: "warning",
              message: "该文件暂不支持在线预览",
              // message: "本视频不支持转码，也不支持直接预览",
        });
      }
    },
    getIcon(type, file_type, file_ext) {
      return getIcon(type, file_type, file_ext);
    },
    toggleSelectAll() {
      let status = this.selectedDatas.length === 0;
      if (status) {
        this.selectedDatas = this.datas.map((data) => {
          return data;
        });
      } else {
        this.selectedDatas = [];
      }
      this.datas.map((data) => {
        data.isSelected = status ? true : false;
        return data;
      });
    },
    selectRow(data) {
      if (this.isProcessing) {
        return false;
      }
      if (data.isSelected) {
        let index = this.selectedDatas.indexOf(data);
        data.isSelected = false;
        this.selectedDatas.splice(index, 1);
      } else {
        data.isSelected = true;
        this.selectedDatas.push(data);
      }
    },
    resourceSearch() {
      this.selectedDatas = [];
      this.datas = [];
      this.loading = true;
      this.nothing = false;
      resourceSearch(this.listQuery)
        .then((res) => {
          if (res.status_code === 200) {
            this.loading = false;
            this.count = res.entity.total;
            if (this.count) {
              this.datas = res.entity.datas.map((data) => {
                data.isSelected = false;
                data.isEdit = false;
                return data;
              });
              this.sortBy();
            } else {
              this.nothing = true;
            }
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err,
          });
        });
    },
  },
  mounted() {
    setTimeout(() => {
      for (let key in this.status) {
        this.status[key] = true;
      }
    }, 500);
    let that = this;
    /*滚动停留*/
    let toplist_height = $("#toplist").offset().top; //获取div1的高度
    //滚动处理div
    $(window).scroll(function () {
      let this_scrollTop = $(this).scrollTop();
      if (this_scrollTop > toplist_height) {
        that.showA1 = true;
      }
      if (this_scrollTop < toplist_height) {
        that.showA1 = false;
      }
    });
    // 文件上传成功的回调
    Bus.$on("fileSuccess", () => {
      this.resourceSearch();
      // console.log("文件上传成功");
    });
    document.getElementById("dropArea").addEventListener("dragenter", (e) => {
      e.stopPropagation();
      e.preventDefault();
      Bus.$emit("dragenter");
    });
  },
  destroyed() {
    Bus.$off("fileSuccess");
  },
};
</script>

<style scoped>
.drive .grids .itemlist {
  padding: 20px 10px 0px 10px;
  position: relative;
}
.drive .lists .file-name {
  max-width: calc(100% - 10px);
  font-weight: bold;
  height: 40px;
  line-height: 30px;
}
.drive .grids .file-name {
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media (max-width: 768px) {
  .drive .lists .file-name {
    padding-top: 0px;
  }
  .file-name {
    font-weight: normal !important;
  }
  .file-path {
    display: none;
  }
  .drive .lists .isTransed,
  .drive .grids .isTransed,
  .drive .lists .isShared {
    display: none;
  }
}
@media (min-width: 768px) {
  .drive .lists .file-name {
    padding-top: 10px;
  }
  .file-path {
    line-height: 20px;
    font-size: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .drive .lists .isTransed {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    line-height: 18px;
    font-weight: normal;
    font-size: 12px;
    margin: 6px 0px 6px 3px;
  }
  .drive .grids .isTransed {
    position: absolute;
    right: 25px;
    top: 10px;
    font-size: 12px;
  }
  .drive .lists .isShared {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    line-height: 18px;
    font-weight: normal;
    font-size: 12px;
    margin: 6px 0px 6px 3px;
    opacity: 0.65;
    color: #aaa;
  }
}
.file-name p:hover,
.file-path:hover {
  color: #006adf;
}
.no-click {
  color: #ddd;
  cursor: default;
}
.drive .lists .file-name-data {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 30px;
}
.drive .grids .file-name-data {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.drive .lists .isLocked {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  line-height: 18px;
  font-weight: normal;
  font-size: 12px;
  margin: 6px 0px 6px 3px;
  opacity: 0.65;
  color: #aaa;
}
.drive .grids .isLocked {
  position: absolute;
  right: 40px;
  top: 10px;
  font-size: 12px;
  opacity: 0.65;
  color: #aaa;
}
.drive .grids .isShared {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 12px;
  opacity: 0.65;
  color: #aaa;
}
</style>